import React from 'react';
import { Box } from '@mui/material';
import BookmarksContainer from '../components/bookmarksContainer/BookmarksContainer';
import NotificationContainer from '../components/notification/NotificationPanel';

const Bookmarks = () => {

    return (
        <Box
            sx={{
                display: 'flex',
                flexGrow: 1,
                justifyContent: 'center', // Centering horizontally
                alignItems: 'stretch',
                gap: 1,
                // alignItems: 'flex-start', // Aligning items to the start vertically
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    // height: '100%',
                    margin: '0 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    gap: 1,
                }}
            >
                <BookmarksContainer />
            </Box>

            <NotificationContainer />
        </Box>
    );
};

export default Bookmarks;
